import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddMaterialPanelService } from '../../services/add-material-panel.service';
import { fuseAnimations } from '../../../../@fuse/animations';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MaterialsService } from '../../api/materials.service';
import { OrdersService } from '../../api/orders.service';
import { ProductModel } from '../../api/products.service';
import { GT2PageAbstract } from '../../content/abstract/GT2PageAbstract';
import { ItemUrlFinder } from '../../utils/item-url-finder';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { CreateMaterialComponent } from '../dialogs/create-material/create-material.component';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { Gt2PrimengModule } from '../../modules/gt2-primeng.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBadgeModule } from '@angular/material/badge';
import { NgPipesModule } from 'ngx-pipes';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';
import {
  copyArrayItem,
  DragDropModule,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MobileLayoutService } from '../../services/mobile-layout.service';
import { TagsService } from '../tags/tags.service';
import { MaterialCategoryService } from '../../api/material-category.service';

@Component({
  selector: 'app-order-material-dnd',
  templateUrl: './order-material-dnd.component.html',
  styleUrls: ['./order-material-dnd.component.scss'],
  animations: fuseAnimations,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    Gt2PrimengModule,
    MatButtonModule,
    MatTooltipModule,
    DragDropModule,
    MatInputModule,
    MatIconModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    NgPipesModule,
    ScrollingModule,
  ],
})
export class OrderMaterialDndComponent
  extends GT2PageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  materials?: ProductModel[];
  combo: any[] = [];
  isLoading: boolean = false;
  isEmpty: boolean = true;
  creationMode: boolean = false;
  applyCall: boolean = true;
  @ViewChild('filter') filter?: ElementRef;
  @ViewChild('productList') productList: ElementRef | any;
  filterValue: string = '';
  newDialogRef: any;
  fromEventSubscription?: Subscription;
  orderUUID: string | any;
  defaultQty: number = 1;
  isSmallScreen: boolean = false;
  isMediumScreen: boolean = false;
  readonly mobileLayout = inject(MobileLayoutService);

  // Filtres additionnels (catégorie de matériel + tags) — mêmes sources que la
  // page liste des matériels.
  materialCategories: any[] = [];
  selectedCategoryUuid: string | null = null;
  availableTags: any[] = [];
  selectedTagUuids: string[] = [];

  constructor(
    private panelService: AddMaterialPanelService,
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    public materialsService: MaterialsService,
    public ordersService: OrdersService,
    private dialog: MatDialog,
    public router: Router,
    private toastr: ToastrService,
    private logger: NGXLogger,
    private breakpointObserver: BreakpointObserver,
    private tagsService: TagsService,
    private materialCategoryService: MaterialCategoryService,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);
    const data = this.panelService.getData();
    if (data?.orderUUID) {
      this.orderUUID = data.orderUUID;
    }
    if (data?.guest_count) {
      this.defaultQty = data.guest_count;
    }
  }

  ngOnInit() {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe({
      next: (result) => {
        this.isSmallScreen = result.matches;
      },
    });
    this.breakpointObserver.observe(['(max-width: 1400px)']).subscribe({
      next: (result) => {
        this.isMediumScreen = result.matches;
      },
    });
    // this.loadProductList();

    this.materialCategoryService.getMaterialCategories().subscribe({
      next: (response: any) => {
        this.materialCategories = response?.data ?? [];
      },
      error: (error: any) => {
        this.logger.error(
          'OrderMaterialDndComponent.getMaterialCategories() -> ERROR: ' +
            JSON.stringify(error),
        );
      },
    });

    // Mêmes familles de tags que le filtre de la page liste des matériels
    // (type + tags sur mesure).
    const tagFamilies = [
      TagsService.TAG_FAMILY_MATERIAL_TYPE,
      TagsService.TAG_FAMILY_MATERIAL_CUSTOM,
    ];
    for (const family of tagFamilies) {
      this.tagsService.getTagsByFamily(family).subscribe({
        next: (response: any) => {
          const tags = response.data || response || [];
          this.availableTags = [
            ...this.availableTags,
            ...tags.filter(
              (t: any) => !this.availableTags.some((at) => at.uuid === t.uuid),
            ),
          ];
        },
      });
    }
  }

  ngAfterViewInit(): void {
    this.fromEventSubscription = fromEvent(this.filter?.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          // //this.logger.info("OrderMaterialDndComponent.onFilterChange() -> " + this.productList);
          // this.productList.nativeElement.scrollTop = 0;
          // if (this.filterValue.length >= 3 || this.filterValue === '')
          if (this.canSearch) {
            this.loadProductList();
          } else {
            this.materials = [];
            this.isEmpty = true;
          }
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {}

  // Une recherche est possible dès qu'il y a un mot-clé (≥2 caractères, comme
  // le debounce) OU un filtre catégorie/tags actif — les filtres seuls
  // permettent de naviguer par catégorie sans taper de texte.
  get hasActiveFilters(): boolean {
    return !!this.selectedCategoryUuid || this.selectedTagUuids.length > 0;
  }

  get canSearch(): boolean {
    return (this.filterValue?.trim().length ?? 0) >= 2 || this.hasActiveFilters;
  }

  public onMaterialFilterChange(): void {
    if (this.productList?.nativeElement) {
      this.productList.nativeElement.scrollTop = 0;
    }
    if (this.canSearch) {
      this.loadProductList();
    } else {
      this.materials = [];
      this.isEmpty = true;
    }
  }

  public loadProductList(): void {
    this.isLoading = true;
    this.isEmpty = false;
    this.materialsService
      .getMaterials(
        this.filterValue,
        this.selectedCategoryUuid,
        this.selectedTagUuids,
      )
      .subscribe({
      next: (response) => {
        // //this.logger.info("OrderMaterialDndComponent.getProducts() -> SUCCESS>>: " + JSON.stringify(response));

        this.isLoading = false;
        if (response.data.length > 0) {
          this.materials = response.data;
          this.isEmpty = false;
          this.productList.nativeElement.scrollTop = 0;
        } else {
          this.isEmpty = true;
          this.materials = [];
        }
      },
      error: (error) => {
        this.logger.error(
          'OrderMaterialDndComponent.getProducts() -> ERROR: ' +
            JSON.stringify(error),
        );
        this.handleAPIError(error, this.dialog, null, null, this.router);
        this.isLoading = false;
        this.isEmpty = true;
      },
    });
  }

  public onFilterChange(): void {
    // //this.logger.info("OrderMaterialDndComponent.onFilterChange()");
    this.productList.nativeElement.scrollTop = 0;
  }

  public onSaveProducts(): void {
    // Prevent double-click by checking if already loading
    if (this.isLoading) {
      return;
    }
    // //this.logger.info("OrderMaterialDndComponent.onSaveProducts() -> products: " + JSON.stringify(this.combo));
    this.isLoading = true;
    this.ordersService
      .addMaterial(this.orderUUID, { materials: this.combo })
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.panelService.emitResult(response.data);
        },
        error: (error: any) => {
          this.logger.error(
            'OrderMaterialDndComponent.getProducts() -> ERROR: ' +
              JSON.stringify(error),
          );
          this.handleAPIError(error, this.dialog, null, null, this.router);
          this.isLoading = false;
        },
      });
  }

  public onDrop(event: any) {
    if (event.previousContainer === event.container) {
      moveItemInArray(this.combo, event.previousIndex, event.currentIndex);
    } else {
      // //this.logger.info(event.source);
      // //this.logger.info(event.source.className.indexOf("combo-list"));
      if (event.item.data == undefined) {
        return;
      }

      // if (event.source.className.indexOf('combo-list') !== -1) {
      //   this.onProductChildDrop(event);
      //   return;
      // }

      // //this.logger.info("OrderMaterialDndComponent.onDrop() -> item: " + event.item.data);
      // event.item.data.qty = 1;

      const items: any[] = this.combo.filter((item) => {
        return item.uuid === event.item.data.uuid;
      });
      // //this.logger.info("OrderMaterialDndComponent.onDrop() -> items: " + items.length);
      if (items && items.length > 0) {
        event.item.data.qty = event.item.data.qty + 1;
      } else {
        event.item.data.qty = this.defaultQty;
        copyArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex,
        );
      }
    }
  }

  public onProductChildDrop(event: any) {
    // //this.logger.info("OrderMaterialDndComponent.onProductChildDrop() -> " + JSON.stringify(event.item.data));
    // //this.logger.info("CreateComboComponent.onProductChildDrop() -> " + JSON.stringify(this.product.childs));
    // //this.logger.info(event);
  }

  public onRemoveItem(item: any, index: number) {
    // //this.logger.info("OrderMaterialDndComponent.onRemoveItem() -> index: " + index);
    item.qty = 0;
    for (let i = 0; i < this.combo.length; ++i) {
      if (this.combo[i] === item) {
        this.combo.splice(i, 1);
        break;
      }
    }
  }

  public onAddItem(item: any, doAddItemInModel: boolean = false) {
    const items: any[] = this.combo.filter((filterItem) => {
      // //this.logger.info(filterItem.uuid === item.uuid);
      return filterItem.uuid === item.uuid;
    });

    if (items.length === 0) {
      // item.qty = 1;
      item.qty = this.defaultQty;
      this.combo.push(item);
    } else {
      items[0].qty++;
    }
    // //this.logger.info("OrderMaterialDndComponent.onAddItem() -> items: " + items.length);
  }

  public onLessItem(item: any, i: number): void {
    item.qty -= 1;

    if (item.qty === 0) {
      this.onRemoveItem(item, i);
    }
  }

  public onRemove(event: any) {
    // //this.logger.info("CreateComboComponent.onRemove() -> combo: " + this.combo.length);
    // //this.logger.info("OrderMaterialDndComponent.onRemove() -> combo: " + event);

    if (event.value.qty > 1) {
      event.value.qty -= 1;
      this.combo.push(event.value);
    }
  }

  public clearSearch(): void {
    this.filterValue = '';
    // Des filtres catégorie/tags encore actifs continuent de piloter la liste.
    if (this.hasActiveFilters) {
      this.loadProductList();
    } else {
      this.materials = [];
      this.isEmpty = true;
    }
  }

  public onItemQtyChange(event: any, item: any): void {
    // Mutate in place: keeping the same object identity prevents the @for
    // (track comb) from destroying/recreating the row, which would make the
    // input lose focus on every keystroke.
    item.qty = parseInt(event) || event;
  }

  public onCreateProduct(): void {
    // //this.logger.info("OrderMaterialDndComponent.onCreateProduct()");
    this.newDialogRef = this.dialog.open(CreateMaterialComponent, {
      width: '340px',
      disableClose: false,
      data: {
        autoRedirect: false,
        uuid_order: this.orderUUID,
      },
    });

    this.newDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          // //this.logger.info("OrderMaterialDndComponent.onCreateMaterial() -> SUCCESS: " + JSON.stringify(result));
          // this.toastr.success("", this.translate.instant("GENERIC.API_CALL_SUCCESS.CREATE_SUCCESS"));
          result.qty = 1;
          this.combo.push(result);
          if (this.canSearch) {
            this.loadProductList();
          }
        }
        this.newDialogRef = null;
      },
    });
  }

  public onOpenInNewTab(item: any): void {
    const prefix = localStorage.getItem('PREFIX') || '';
    window.open(prefix + ItemUrlFinder.getItemURL(item), '_blank');
  }

  public close(): void {
    this.panelService.emitResult(false);
  }

  /** Invite à taper une recherche (moins de 2 caractères, aucun filtre, liste vide). */
  get showSearchMaterialHint(): boolean {
    return (
      this.isEmpty &&
      !this.isLoading &&
      !this.hasActiveFilters &&
      (this.filterValue?.trim().length ?? 0) < 3
    );
  }

  /** Aucun résultat après appel API (mot-clé suffisant ou filtre actif). */
  get showNoSearchResults(): boolean {
    return (
      this.isEmpty &&
      !this.isLoading &&
      (this.hasActiveFilters || (this.filterValue?.trim().length ?? 0) >= 3)
    );
  }
}
